import React from 'react';
import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import Specs from '../components/Specs';
import Technology from '../components/Technology';
import Missions from '../components/Missions';
import Gallery from '../components/Gallery';
import About from '../components/About';
import Contact from '../components/Contact';
import Footer from '../components/Footer';
import ScanOverlay from '../components/ScanOverlay';

export default function HomePage() {
  return (
    <div className="relative bg-[#05080d] text-[#d8e3f0] min-h-screen">
      <ScanOverlay />
      <Navbar />
      <main className="relative z-10">
        <Hero />
        <Specs />
        <Technology />
        <Missions />
        <Gallery />
        <About />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
